if (!customElements.get('lc-slider')) {
  customElements.define(
    'lc-slider',
    class LcSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.slidesCount = this.querySelectorAll('.swiper-slide').length;
        if (this.slidesCount < 2) {
          this.classList.add('lc-slider--static');
          return;
        }

        if (window.FoxTheme && FoxTheme.Motion && typeof FoxTheme.Motion.inView === 'function') {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '300px 0px 300px 0px' });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        if (this.carousel && this.carousel.slider) {
          this.carousel.slider.destroy(true, true);
          this.carousel = null;
        }
      }

      init() {
        if (this.carousel) return;

        const data = this.dataset;
        const perView = parseFloat(data.perView) || 1;
        const perViewMobile = parseFloat(data.perViewMobile) || perView;
        const gap = parseInt(data.gap, 10) || 0;
        const gapMobile = parseInt(data.gapMobile, 10);
        const effect = data.effect || 'slide';
        const autoplayDelay = parseInt(data.autoplay, 10) || 0;
        const loop = data.loop === 'true' && this.slidesCount > perView;

        const modules = [];
        const options = {
          slidesPerView: perViewMobile,
          spaceBetween: isNaN(gapMobile) ? gap : gapMobile,
          speed: parseInt(data.speed, 10) || 500,
          loop: loop,
          grabCursor: data.grabCursor === 'true',
          allowTouchMove: data.allowTouch !== 'false',
          threshold: 2,
          watchOverflow: true,
          a11y: { enabled: true },
          breakpoints: {
            750: {
              slidesPerView: perView,
              spaceBetween: gap,
            },
          },
          on: {
            slideChange: (swiper) => this.onSlideChange(swiper),
            init: (swiper) => this.onInit(swiper),
          },
        };

        if (data.centered === 'true') {
          options.centeredSlides = true;
        }

        if (effect === 'fade') {
          modules.push(FoxTheme.Swiper.EffectFade);
          options.effect = 'fade';
          options.fadeEffect = { crossFade: true };
        }

        const pagination = this.querySelector('.lc-slider__pagination');
        if (pagination) {
          options.pagination = { el: pagination, clickable: true };
        }

        const next = this.querySelector('[data-slider-next]');
        const prev = this.querySelector('[data-slider-prev]');
        if (next && prev) {
          options.navigation = { nextEl: next, prevEl: prev };
        }

        if (autoplayDelay > 0) {
          modules.push(FoxTheme.Swiper.Autoplay);
          options.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: data.pauseOnHover === 'true',
          };
          this.classList.add('lc-slider--autoplay');
          this.style.setProperty('--swiper-autoplay-delay', autoplayDelay + 1000 + 'ms');
        }

        this.carousel = new window.FoxTheme.Carousel(this, options, modules);
        this.carousel.init();
        this.slider = this.carousel.slider;
      }

      onInit(swiper) {
        const activeBullet = this.querySelector('.swiper-pagination-bullet-active');
        if (activeBullet) {
          activeBullet.classList.remove('swiper-pagination-bullet-active');
          void activeBullet.offsetWidth;
          activeBullet.classList.add('swiper-pagination-bullet-active');
        }
        this.dispatchEvent(new CustomEvent('lc-slider:init', { detail: { swiper } }));
      }

      onSlideChange(swiper) {
        this.dispatchEvent(new CustomEvent('lc-slider:slidechange', { detail: { swiper } }));
      }
    }
  );
}
